export enum LoginModalStep {
  RegistrationType = "registration_type",
  Didox = "didox",
  SelfEmployed = "self_employed",
}
